var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex justify-center items-center h-8 px-4 rounded-full whitespace-no-wrap shadow-chip",class:_vm.classes},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }